/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_DisabledInputs */

const cs_clients_comm_disabled = /** @type {(inputs: Clients_Comm_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vypnuto`)
};

const en_clients_comm_disabled = /** @type {(inputs: Clients_Comm_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Clients_Comm_DisabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_disabled = /** @type {((inputs?: Clients_Comm_DisabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_DisabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_disabled(inputs)
	return cs_clients_comm_disabled(inputs)
});